
import React from "react";
import { RouteObject } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import UserManagement from "@/pages/admin/UserManagement";
import EventsManagement from "@/pages/admin/EventsManagement";
import SystemSettings from "@/pages/admin/SystemSettings";
import EmailTemplates from "@/pages/admin/EmailTemplates";

import { UserRoles } from "@/contexts/auth/enums";
import { sendPageView } from "@/services/analyticsService";
import AdminLayout from "@/pages/admin/AdminLayout";

const AdminRoutes = (): RouteObject[] => [
  {
    path: "/admin",
    element: (
      <ProtectedRoute 
        requireAuth={true} 
        requiredRole={UserRoles.ADMIN}
        onEnter={() => sendPageView("Admin")}
      >
        <AdminLayout>
          <AdminDashboard />
        </AdminLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/admin/dashboard",
    element: (
      <ProtectedRoute 
        requireAuth={true} 
        requiredRole={UserRoles.ADMIN}
        onEnter={() => sendPageView("Admin - Vezérlőpult")}
      >
        <AdminLayout>
          <AdminDashboard />
        </AdminLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/admin/analytics",
    element: (
      <ProtectedRoute 
        requireAuth={true} 
        requiredRole={UserRoles.ADMIN}
        onEnter={() => sendPageView("Admin - Analitika")}
      >
        <AdminLayout>
          <AdminDashboard />
        </AdminLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/admin/users",
    element: (
      <ProtectedRoute 
        requireAuth={true} 
        requiredRole={UserRoles.ADMIN}
        onEnter={() => sendPageView("Admin - Felhasználók kezelése")}
      >
        <AdminLayout>
          <UserManagement />
        </AdminLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/admin/events",
    element: (
      <ProtectedRoute 
        requireAuth={true} 
        requiredRole={UserRoles.ADMIN}
        onEnter={() => sendPageView("Admin - Események kezelése")}
      >
        <AdminLayout>
          <EventsManagement />
        </AdminLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/admin/settings",
    element: (
      <ProtectedRoute 
        requireAuth={true} 
        requiredRole={UserRoles.ADMIN}
        onEnter={() => sendPageView("Admin - Rendszerbeállítások")}
      >
        <AdminLayout>
          <SystemSettings />
        </AdminLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/admin/email-templates",
    element: (
      <ProtectedRoute 
        requireAuth={true} 
        requiredRole={UserRoles.ADMIN}
        onEnter={() => sendPageView("Admin - E-mail sablonok")}
      >
        <AdminLayout>
          <EmailTemplates />
        </AdminLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/admin/notifications",
    element: (
      <ProtectedRoute 
        requireAuth={true} 
        requiredRole={UserRoles.ADMIN}
        onEnter={() => sendPageView("Admin - Értesítések")}
      >
        <AdminLayout>
          <div className="p-6">
            <h1 className="text-2xl font-bold">Értesítések kezelése</h1>
            <p className="text-muted-foreground mt-2">Értesítések beállítása és áttekintése</p>
          </div>
        </AdminLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/admin/reports",
    element: (
      <ProtectedRoute 
        requireAuth={true} 
        requiredRole={UserRoles.ADMIN}
        onEnter={() => sendPageView("Admin - Jelentések")}
      >
        <AdminLayout>
          <div className="p-6">
            <h1 className="text-2xl font-bold">Jelentések</h1>
            <p className="text-muted-foreground mt-2">Rendszerjelentések áttekintése</p>
          </div>
        </AdminLayout>
      </ProtectedRoute>
    )
  }
];

export default AdminRoutes;
